<script setup>
import { onMounted, ref, inject, watch, nextTick } from "vue";
import hand_feel_png from "@/assets/img/hand_feel.png";
import skin_comfort_png from "@/assets/img/skin_comfort.png";
import thermal_comfort_png from "@/assets/img/thermal_comfort.png";
import i18n from "@/i18n";
import { starUI } from "@/utils/common";
import FeelTipBar from "@/components/feel-tip-bar.vue";
import { get_database_radar_map } from "@/service/apiList/products.js";
const tabList = inject("tabList");
const current_tab = inject("current_tab");
import { radarChart, radar1Chart } from "@/utils/chart.js";
import fileActionCom from "../common/fileAction.vue";
const detailInfo = inject("detailInfo");
import { getLangValue } from "@/utils/common"; //获取后端语言
const product_name = ref(""); // 产品名称
const uploadFileList = ref([]);
const hasValue = (value) => value !== null && value !== undefined && value !== "";
const myLoading = ref(false); //加载效果
// const templateNameList = inject('templateNameList') //全量模板名称
const radarData = ref({}); // 存雷达信息
const comfort_info_data = ref([
  {
    image: hand_feel_png,
    title: getLangValue("radar_chart.feel"),
    data: [],
    fabricId: "",
    fabricName: "",
    list: [],
    id: "hand_feel_chart",
  },
  {
    image: skin_comfort_png,
    title: getLangValue("radar_chart.skin"),
    data: [],
    fabricId: "",
    fabricName: "",
    list: [],
    id: "skin_comfort_chart",
  },
  {
    image: thermal_comfort_png,
    title: getLangValue("radar_chart.heat"),
    data: [],
    fabricId: "",
    fabricName: "",
    // list: [{
    //     id: 'xxx'
    // }],
    id: "thermal_comfort_chart",
  },
]);

//methods
const getChartData = (id) => {
  const data = comfort_info_data.value
    .find((item) => item.id === id)
    .data.map((item1) => item1.score);
  const avg = comfort_info_data.value
    .find((item) => item.id === id)
    .data.map((item1) => item1.avg);
  // const name = product_name.value
  const name = comfort_info_data.value.find(
    (item) => item.id === id
  ).fabricName;
  const obj = {
    data,
    avg,
    name,
  };
  return obj;
};
const setCurrentHandFabric = async (item, key, id) => {
  comfort_info_data.value[key].fabricId = item.id;
  comfort_info_data.value[key].fabricName = item.name;
  // 更新数据
  updateData(id, item.id);
  // 更新视图
  switch (id) {
    case "hand_feel_chart":
      initHandChart(getChartData(id));
      break;
    case "skin_comfort_chart":
      iniSkinChart(getChartData(id));
      break;
    default:
      console.error("Invalid chart id");
  }
};
const initHandChart = ({ data, avg, name }) => {
  const [a, b, c, d] = data;
  const [a1, b1, c1, d1] = avg;
  let data1 = [b, a, c, d];
  let avg1 = [b1, a1, c1, d1];
  let options = {
    data: data1,
    ave: avg1,
    color: "#50C3E6",
    name: name,
    chartDom: document.getElementById("hand_feel_chart"),
  };
  radarChart(options, "pc", "hand");
};

const iniSkinChart = ({ data, avg, name }) => {
  // skin 需要做特殊处理
  // stiff pricking  顺序
  const [a, b, c, d] = data;
  const [a1, b1, c1, d1] = avg;
  let data1 = [b, a, c, d];
  let avg1 = [b1, a1, c1, d1];
  let options = {
    data: data1,
    ave: avg1,
    color: "#13C56B",
    name: name,
    chartDom: document.getElementById("skin_comfort_chart"),
  };
  radarChart(options, "pc", "skin");
};

const iniHeatChart = ({ data, avg, name }) => {
  let options = {
    data: data,
    ave: avg,
    color: "#ED5E5E",
    name: name,
    chartDom: document.getElementById("thermal_comfort_chart"),
  };
  // console.log(options);
  radar1Chart(options);
};

const setChart = () => {
  for (const item in comfort_info_data.value) {
    const data = comfort_info_data.value[item].data.map((item1) => item1.score);
    const avg = comfort_info_data.value[item].data.map((item1) => item1.avg);
    const name = product_name.value;
    const obj = {
      data,
      avg,
      name,
    };
    if (comfort_info_data.value[item].id == "hand_feel_chart") {
      initHandChart(obj);
    } else if (comfort_info_data.value[item].id == "skin_comfort_chart") {
      iniSkinChart(obj);
    } else {
      // console.log(obj);
      iniHeatChart(obj);
    }
  }
};
const filterImglist = (valList, imageInfo) => {
  if (
    valList != null &&
    valList &&
    valList.length &&
    Object.keys(valList).length
  ) {
    const fileList = valList.map((item) => {
      return imageInfo[item];
    });
    return fileList;
  }
  return [];
};

const updateData = (id) => {
  // 更新数据
  if (id == "hand_feel_chart") {
    let data_ftt = [
      {
        name: getLangValue("radar_chart.smoothness"),
        value: 0,
        score: 0,
        avg: 0,
        type: "hand_roughness",
      },
      {
        name: getLangValue("radar_chart.softness"),
        value: 0,
        score: 0,
        avg: 0,
        type: "hand_softness",
      },
      {
        name: getLangValue("radar_chart.warmth"),
        value: 0,
        score: 0,
        avg: 0,
        type: "hand_warmth",
      },
      {
        name: getLangValue("radar_chart.total"),
        value: 0,
        score: 0,
        avg: 0,
      },
    ];
    let format_hand_feeling = {};
    let score_hand_feeling = {};
    let avg_score_hand_feeling = {};
    let data = getDataById("hand_feeling", comfort_info_data.value[0].fabricId);
    format_hand_feeling = data.format_hand_feeling;
    score_hand_feeling = data.score_hand_feeling;
    avg_score_hand_feeling = data.avg_score_hand_feeling;
    if (Object.keys(format_hand_feeling).length) {
      // 输入
      data_ftt[0].value = format_hand_feeling.smooth;
      data_ftt[1].value = format_hand_feeling.soft;
      data_ftt[2].value = format_hand_feeling.warmth;
      data_ftt[3].value = format_hand_feeling.comprehensive_degree;
    }
    if (Object.keys(score_hand_feeling).length) {
      // 输入框的值
      data_ftt[0].score = score_hand_feeling.smooth;
      data_ftt[1].score = score_hand_feeling.soft;
      data_ftt[2].score = score_hand_feeling.warmth;
      data_ftt[3].score = score_hand_feeling.comprehensive_degree;
    }
    if (avg_score_hand_feeling && Object.keys(avg_score_hand_feeling).length) {
      // 输入框的值
      data_ftt[0].avg = avg_score_hand_feeling.smooth;
      data_ftt[1].avg = avg_score_hand_feeling.soft;
      data_ftt[2].avg = avg_score_hand_feeling.warmth;
      data_ftt[3].avg = avg_score_hand_feeling.comprehensive_degree;
    }
    // 有值才显示
    if (
      Object.keys(format_hand_feeling).length &&
      Object.keys(score_hand_feeling).length &&
      Object.keys(avg_score_hand_feeling).length &&
      avg_score_hand_feeling &&
      (format_hand_feeling.smooth >= 0 ||
        format_hand_feeling.soft >= 0 ||
        format_hand_feeling.warmth >= 0 ||
        format_hand_feeling.comprehensive_degree >= 0)
    ) {
      comfort_info_data.value[0].data = [...data_ftt];
    }
  } else {
    // 肤感部分
    let data_skin = [
      {
        name: getLangValue("radar_chart.smoothness"),
        value: 0,
        score: 0,
        avg: 0,
        type: "skin_roughness",
      },
      {
        name: getLangValue("radar_chart.softness"),
        value: 0,
        score: 0,
        avg: 0,
        type: "skin_softness",
      },
      {
        name: getLangValue("radar_chart.warmth"),
        value: 0,
        score: 0,
        avg: 0,
        type: "skin_warmth",
      },
      {
        name: getLangValue("radar_chart.total"),
        value: 0,
        score: 0,
        avg: 0,
      },
    ];
    let format_skin_feeling = {};
    let score_skin_feeling = {};
    let avg_score_skin_feeling = {};
    let data = getDataById("skin_feeling", comfort_info_data.value[1].fabricId);
    format_skin_feeling = data.format_skin_feeling;
    score_skin_feeling = data.score_skin_feeling;
    avg_score_skin_feeling = data.avg_score_skin_feeling;
    if (Object.keys(format_skin_feeling).length) {
      data_skin[0].value = format_skin_feeling.pricking;
      data_skin[1].value = format_skin_feeling.stiff;
      data_skin[2].value = format_skin_feeling.cool;
      data_skin[3].value = format_skin_feeling.comprehensive_degree;
    }
    if (Object.keys(score_skin_feeling).length) {
      // 输入框的值
      data_skin[0].score = score_skin_feeling.pricking;
      data_skin[1].score = score_skin_feeling.stiff;
      data_skin[2].score = score_skin_feeling.cool;
      data_skin[3].score = score_skin_feeling.comprehensive_degree;
    }
    if (Object.keys(avg_score_skin_feeling).length) {
      // 输入框的值
      data_skin[0].avg = avg_score_skin_feeling.pricking;
      data_skin[1].avg = avg_score_skin_feeling.stiff;
      data_skin[2].avg = avg_score_skin_feeling.cool;
      data_skin[3].avg = avg_score_skin_feeling.comprehensive_degree;
    }
    // 有值才显示
    if (
      Object.keys(format_skin_feeling).length &&
      Object.keys(score_skin_feeling).length &&
      Object.keys(avg_score_skin_feeling).length &&
      (format_skin_feeling.pricking >= 0 ||
        format_skin_feeling.stiff >= 0 ||
        format_skin_feeling.cool >= 0 ||
        format_skin_feeling.comprehensive_degree >= 0)
    )
      comfort_info_data.value[1].data = [...data_skin];
  }
};
const getDataById = (type, pid) => {
  // 根据id获取数据
  if (type == "hand_feeling") {
    return radarData.value.list_hand_feeling.find((item) => item.pid == pid);
  } else {
    return radarData.value.list_skin_feeling.find((item) => item.pid == pid);
  }
};

const get_radar_data = async () => {
  // 获取舒适度信息雷达图
  myLoading.value = true;
  const reps = await get_database_radar_map(detailInfo.value.database_list_id);
  myLoading.value = false;
  if (reps.code == 0) {
    radarData.value = reps.payload;
  }
};
// const getValueByKey = (children, key, valueKey = 'value') => {
//     // 通过key来获取  不通过index 顺序修改了会报错
//     if (children) {
//         let obj = children.find(item => item.key == key)
//         return obj ? obj[valueKey] : ''
//     }
//     return ''
// }
// value_heat_and_humidity_comfort:{heat:0,humidity:0,comfort:0}
// value_skin_feeling
// score_hand_feeling
// score_heat_and_humidity_comfort:{heat:0,humidity:0,comfort:0}
// score_skin_feeling:{}
// avg_hand_feeling:{}
// avg_heat_and_humidity_comfort:{}
// avg_score_hand_feeling:{}
// avg_score_heat_and_humidity_comfort:{heat:0,humidity:0,comfort:0}
// avg_score_skin_feeling:{}
// avg_skin_feeling:{}
// list_hand_feeling: []
// list_heat_and_humidity_comfort: []
// list_skin_feeling: []

watch(detailInfo, async (val) => {
  // 设置信息
  // console.log('舒适度信息监听+++', val);
  const { comfort_info, product_info, structures } = val;
  // 判断是否有子集
  if (comfort_info.children.filter((item) => item.show).length == 0) {
    console.log(1);
    tabList.value[1].show = false;
    current_tab.value = 0;
  }
  product_name.value = product_info.children[0].children[0].value;
  // 获取组成机构信息
  const arr = product_info.children.filter((item) => item.key == "热湿舒适度");
  if (arr.length && arr[0].children && arr[0].children.length) {
    let itemsList = [];
    arr[0].children
      .filter((item) => item.extra && item.extra.data && item.extra.data.length)
      .forEach((item) => {
        // 获取name 名称
        // let name = ''
        // if (templateNameList.value.length) {
        //     name = templateNameList.value.filter(item1 => item1.id == item.value).length ? templateNameList.value.filter(item1 => item1.id == item.value)[0].name : ''
        // }
        let mArr = item.extra.data.map((xx) => {
          let pid = "";
          let name = "";
          if (structures && structures.length && structures != null) {
            pid = structures.filter((item1) => item1.id == xx.id)[0]?.pid;
            name = structures.filter((item1) => item1.id == xx.id)[0]?.name;
          }
          return { id: pid, name: name, layer: xx.layer };
        });
        itemsList = [...itemsList, ...mArr];
      });
    if (val.has_dat) {
      if (itemsList.length == 1) {
        // 如果只有一条织物 那数据都是用它
        comfort_info_data.value[0].list = [
          ...comfort_info_data.value[0].list,
          ...itemsList,
        ];
        comfort_info_data.value[1].list = [
          ...comfort_info_data.value[1].list,
          ...itemsList,
        ];
        comfort_info_data.value[0].fabricId = itemsList[0].id;
        comfort_info_data.value[0].fabricName = itemsList[0].name;
        comfort_info_data.value[1].fabricId = itemsList[0].id;
        comfort_info_data.value[1].fabricName = itemsList[0].name;
      } else {
        let arr1 = itemsList.filter((list_d) => list_d.layer == "shell"); //筛选外层
        let arr2 = itemsList.filter((list_d) => list_d.layer == "lining"); //筛选外层
        comfort_info_data.value[0].list = [
          ...comfort_info_data.value[0].list,
          ...arr1,
        ];
        comfort_info_data.value[1].list = [
          ...comfort_info_data.value[1].list,
          ...arr2,
        ];
        console.log(comfort_info_data.value[0].list);
        // console.log(comfort_info_data.value[1].list);
        if (arr1.length) {
          // console.log(itemsList);
          comfort_info_data.value[0].fabricId = arr1[0].id;
          comfort_info_data.value[0].fabricName = arr1[0].name;
        }
        if (arr2.length) {
          // console.log(itemsList);
          comfort_info_data.value[1].fabricId = arr2[0].id;
          comfort_info_data.value[1].fabricName = arr2[0].name;
        }
      }
    }
  }
  // 获取雷达图信息
  await get_radar_data();

  // 需要判断ftt  ftt有的话才会有手感 肤感
  // 判断是否有ftt
  // const arr_ftt = comfort_info.children.filter(item => item.key == 'FTT织物触觉测试')
  // if (arr_ftt.length && arr_ftt[0].value && arr_ftt[0].value.length) {
  let data_ftt = [
    {
      name: getLangValue("radar_chart.smoothness"),
      value: 0,
      score: 0,
      avg: 0,
      type: "hand_roughness",
    },
    {
      name: getLangValue("radar_chart.softness"),
      value: 0,
      score: 0,
      avg: 0,
      type: "hand_softness",
    },
    {
      name: getLangValue("radar_chart.warmth"),
      value: 0,
      score: 0,
      avg: 0,
      type: "hand_warmth",
    },
    {
      name: getLangValue("radar_chart.total"),
      value: 0,
      score: 0,
      avg: 0,
    },
  ];
  let format_hand_feeling = {};
  let score_hand_feeling = {};
  let avg_score_hand_feeling = {};
  if (val.has_dat && radarData.value.list_hand_feeling?.length > 0) {
    // 说明是服装 有多个织物
    let data = comfort_info_data.value[0].fabricId
      ? getDataById("hand_feeling", comfort_info_data.value[0].fabricId)
      : {};
    format_hand_feeling = data.format_hand_feeling || 0;
    score_hand_feeling = data.score_hand_feeling || 0;
    avg_score_hand_feeling = data.avg_score_hand_feeling || 0;
  } else {
    // let comfort_info_ftt_show = getValueByKey(comfort_info.children, 'comfort_info_ftt','show')
    if (val.has_ftt) {
      // 上传了Ftt
      format_hand_feeling = radarData.value.format_hand_feeling;
      score_hand_feeling = radarData.value.score_hand_feeling;
      avg_score_hand_feeling = radarData.value.avg_score_hand_feeling;
    }
  }
  if (format_hand_feeling && Object.keys(format_hand_feeling).length) {
    // 输入
    data_ftt[0].value = format_hand_feeling.smooth;
    data_ftt[1].value = format_hand_feeling.soft;
    data_ftt[2].value = format_hand_feeling.warmth;
    data_ftt[3].value = format_hand_feeling.comprehensive_degree;
  }
  if (score_hand_feeling && Object.keys(score_hand_feeling).length) {
    // 输入框的值
    data_ftt[0].score = score_hand_feeling.smooth;
    data_ftt[1].score = score_hand_feeling.soft;
    data_ftt[2].score = score_hand_feeling.warmth;
    data_ftt[3].score = score_hand_feeling.comprehensive_degree;
  }
  if (avg_score_hand_feeling && Object.keys(avg_score_hand_feeling).length) {
    // 输入框的值
    data_ftt[0].avg = avg_score_hand_feeling.smooth;
    data_ftt[1].avg = avg_score_hand_feeling.soft;
    data_ftt[2].avg = avg_score_hand_feeling.warmth;
    data_ftt[3].avg = avg_score_hand_feeling.comprehensive_degree;
  }
  // 有值才显示
  if (format_hand_feeling &&
    score_hand_feeling &&
    avg_score_hand_feeling &&
    Object.keys(format_hand_feeling).length &&
    Object.keys(score_hand_feeling).length &&
    Object.keys(avg_score_hand_feeling).length &&
    avg_score_hand_feeling &&
    (format_hand_feeling.smooth >= 0 ||
      format_hand_feeling.soft >= 0 ||
      format_hand_feeling.warmth >= 0 ||
      format_hand_feeling.comprehensive_degree >= 0)
  ) {
    comfort_info_data.value[0].data = [...data_ftt];
  }

  // 肤感部分
  let format_skin_feeling = {};
  let score_skin_feeling = {};
  let avg_score_skin_feeling = {};
  if (val.has_dat && radarData.value.list_skin_feeling?.length > 0) {
    // 说明是服装 有多个织物
    let data = comfort_info_data.value[1].fabricId
      ? getDataById("skin_feeling", comfort_info_data.value[1].fabricId)
      : {};
    format_skin_feeling = data.format_skin_feeling || 0;
    score_skin_feeling = data.score_skin_feeling || 0;
    avg_score_skin_feeling = data.avg_score_skin_feeling || 0;
  } else {
    // 有ftt模块就显示  都是与Ftt文件有关
    //   let comfort_info_ftt_show = getValueByKey(comfort_info.children, 'comfort_info_ftt','show')
    if (val.has_ftt) {
      // 有fft
      format_skin_feeling = radarData.value.format_skin_feeling;
      score_skin_feeling = radarData.value.score_skin_feeling;
      avg_score_skin_feeling = radarData.value.avg_score_skin_feeling;
    }
  }

  let data_skin = [
    {
      name: getLangValue("radar_chart.smoothness"),
      value: 0,
      score: 0,
      avg: 0,
      type: "skin_roughness",
    },
    {
      name: getLangValue("radar_chart.softness"),
      value: 0,
      score: 0,
      avg: 0,
      type: "skin_softness",
    },
    {
      name: getLangValue("radar_chart.warmth"),
      value: 0,
      score: 0,
      avg: 0,
      type: "skin_warmth",
    },
    {
      name: getLangValue("radar_chart.total"),
      value: 0,
      score: 0,
      avg: 0,
    },
  ];
  if (format_skin_feeling && Object.keys(format_skin_feeling).length) {
    data_skin[0].value = format_skin_feeling.pricking;
    data_skin[1].value = format_skin_feeling.stiff;
    data_skin[2].value = format_skin_feeling.cool;
    data_skin[3].value = format_skin_feeling.comprehensive_degree;
  }
  if (score_skin_feeling && Object.keys(score_skin_feeling).length) {
    // 输入框的值
    data_skin[0].score = score_skin_feeling.pricking;
    data_skin[1].score = score_skin_feeling.stiff;
    data_skin[2].score = score_skin_feeling.cool;
    data_skin[3].score = score_skin_feeling.comprehensive_degree;
  }
  if (avg_score_skin_feeling && Object.keys(avg_score_skin_feeling).length) {
    // 输入框的值
    data_skin[0].avg = avg_score_skin_feeling.pricking;
    data_skin[1].avg = avg_score_skin_feeling.stiff;
    data_skin[2].avg = avg_score_skin_feeling.cool;
    data_skin[3].avg = avg_score_skin_feeling.comprehensive_degree;
  }
  // 有值才显示
  if (
    format_skin_feeling &&
    score_skin_feeling &&
    avg_score_skin_feeling &&
    Object.keys(format_skin_feeling).length &&
    Object.keys(score_skin_feeling).length &&
    Object.keys(avg_score_skin_feeling).length &&
    (format_skin_feeling.pricking >= 0 ||
      format_skin_feeling.stiff >= 0 ||
      format_skin_feeling.cool >= 0 ||
      format_skin_feeling.comprehensive_degree >= 0)
  )
    comfort_info_data.value[1].data = [...data_skin];
  // }
  // }
  // 判断是否有热舒适度dat
  const arr_comfort = comfort_info.children.filter(
    (item) => item.key == "comfort_info_humidity_heat_comfort"
  );
  comfort_info_data.value[2].data = [];
  if (arr_comfort.length && arr_comfort[0].show && val.has_dat) {
    let data_comfort = [
      {
        name: getLangValue("radar_chart.comfort_value"),
        value: null,
        score: null,
        avg: null,
        type: "comfort_value",
      },
      {
        name: getLangValue("radar_chart.dampness_sensation"),
        value: null,
        score: null,
        avg: null,
        type: "dampness_sensation",
      },
      {
        name: getLangValue("radar_chart.thermal_sensation"),
        value: null,
        score: null,
        avg: null,
        type: "thermal_sensation",
      },
    ];
    if (radarData.value.format_heat_and_humidity_comfort && Object.keys(radarData.value.format_heat_and_humidity_comfort).length) {
      // 输入框的值
      data_comfort[0].value =
        radarData.value.format_heat_and_humidity_comfort.comfort;
      data_comfort[1].value =
        radarData.value.format_heat_and_humidity_comfort.humidity;
      data_comfort[2].value =
        radarData.value.format_heat_and_humidity_comfort.heat;
    }
    if (radarData.value.score_heat_and_humidity_comfort && Object.keys(radarData.value.score_heat_and_humidity_comfort).length) {
      // score的值
      data_comfort[0].score =
        radarData.value.score_heat_and_humidity_comfort.comfort;
      data_comfort[1].score =
        radarData.value.score_heat_and_humidity_comfort.humidity;
      data_comfort[2].score =
        radarData.value.score_heat_and_humidity_comfort.heat;
    }
    if (
      radarData.value.avg_score_heat_and_humidity_comfort && Object.keys(radarData.value.avg_score_heat_and_humidity_comfort).length
    ) {
      // 输入框的值
      data_comfort[0].avg =
        radarData.value.avg_score_heat_and_humidity_comfort.comfort;
      data_comfort[1].avg =
        radarData.value.avg_score_heat_and_humidity_comfort.humidity;
      data_comfort[2].avg =
        radarData.value.avg_score_heat_and_humidity_comfort.heat;
    }
    data_comfort.forEach((item) => {
      if (!hasValue(item.value)) {
        item.score = null;
        item.avg = null;
      }
    });
    if (data_comfort.some((item) => hasValue(item.value))) {
      comfort_info_data.value[2].data = [...data_comfort];
    }
  }
  //展示图表
  nextTick(() => {
    setChart();
  });
  // 获取文本项 + 附件项信息
  const upList3 = comfort_info.children.filter(
    (item) =>
      item.extra &&
      item.show &&
      (item.extra.myKey == "文本项" || item.extra.myKey == "文本项+附件项")
  );
  if (upList3.length) {
    uploadFileList.value = upList3.map((item) => {
      let m = {
        name: item.name, // 文本名称
        name_en: item.name_en, // 文本名称
        type: item.extra.myKey,
        fieldList: item.children
          .filter(
            (item) => item.key !== "template_attachments" && item.key !== "附件"
          )
          .map((ele) => {
            return {
              name: ele.name, //字段名称
              name_en: ele.name_en, //字段名称
              unit: ele.unit, //字段单位
              key: ele.key,
              value: ele.value,
            };
          }),
        value: item.value,
        imageList: [],
        tabList: item.extra.tabList ? item.extra.tabList : [],
      };
      return m;
    });
    uploadFileList.value.forEach((item) => {
      if (item.value && item.value.length) {
        item.imageList = filterImglist(item.value, val.imageInfo);
      }
    });
    // console.log(uploadFileList.value);
  }
});

onMounted(() => {
  // setChart()
});
</script>
<template>
  <div class="comfortInformation" v-loading="myLoading">
    <!-- <template> -->
    <div v-if="
      comfort_info_data[0].data.length ||
      comfort_info_data[1].data.length ||
      comfort_info_data[2].data.length
    ">
      <div v-for="(item, key) in comfort_info_data" :key="key">
        <div class="d-flex align-items-center" v-if="item.data.length">
          <div style="flex: 1">
            <img :src="item.image" />
          </div>
          <div style="flex: 2">
            <div v-for="(data, kk) in item.data" :key="kk" class="my-3">
              <label class="form-label">{{ data.name }}:</label>
              <div class="d-flex">
                <input type="text" class="form-control" :value="data.value" disabled style="width: 70px" />
                <div v-if="hasValue(data.value)" class="text-warning fs-20 ms-2 mx-4" style="flex: 1">
                  <i v-for="(cls, idx) in starUI(data.score)" :key="idx" :class="cls"></i>
                </div>
                <div v-if="hasValue(data.value)" style="flex: 1; min-width: 150px">
                  <feel-tip-bar v-if="data.type" :barType="data.type" :value="data.score"></feel-tip-bar>
                </div>
              </div>
            </div>
          </div>
          <div style="flex: 2; position: relative" class="px-4">
            <div class="chart-options d-flex align-items-center justify-content-between"
              v-if="item.list && item.list.length">
              <!-- <div>{{ item.title }}</div> -->
              <div class="align-items-center" style="
                  position: absolute;
                  right: 1.5rem !important;
                  top: 0;
                  z-index: 1;
                ">
                <!-- <div>{{ $t('fabric.id') }}:</div> -->
                <!-- <div>{{ item.fabricName }}</div> -->
                <div v-if="item.list.length == 1">{{getLangValue('product-management', "pid")}}:{{ item.fabricId }}</div>
                <div class="btn-group" role="group" v-else>
                  {{getLangValue('product-management', "pid")}}:
                  <button id="btnGroupVerticalDrop1" type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false" style="padding: 0 3px">
                    {{ item.fabricId }}
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                    <span v-for="(hItem, hIndex) in item.list" :key="hIndex"
                      @click="setCurrentHandFabric(hItem, key, item.id)"
                      :class="item.fabricId == hItem.id ? 'active' : ''" class="dropdown-item">{{ hItem.id }}</span>
                  </div>
                </div>

              </div>
            </div>
            <!-- 图表 -->
            <div :id="item.id" style="height: 300px; width: 350px"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 文本框信息 -->
    <div v-if="uploadFileList.length" class="pb-2">
      <div v-for="(item, k) in uploadFileList" :key="k">
        <div class="title py-4" style="border-bottom: 1px solid #e9ebec">
          {{ i18n.global.locale == "en" ? item.name_en : item.name }}
        </div>
        <template v-if="item.type == '文本项'">
          <div class="p-2" v-if="item.fieldList.length">
            <div v-for="(aa, kk) in item.fieldList" :key="kk" class="d-flex p-2"
              style="border-bottom: 1px solid #e9ebec">
              <div style="
                  font-weight: bold;
                  flex: 2;
                  max-width: 200px;
                  font-size: 12px;
                ">
                {{ i18n.global.locale == "en" ? aa.name_en : aa.name }}
              </div>
              <div style="flex: 6">
                {{ aa.value }}{{ aa.unit ? `${aa.unit}` : "" }}
              </div>
            </div>
            <!-- 显示有table的信息 -->
            <template v-if="item.tabList.length">
              <div v-for="(aa, kk) in item.tabList" :key="kk" class="p-2">
                <!-- style="border-bottom: 1px solid #E9EBEC; " -->
                <div style="
                    font-weight: bold;
                    flex: 2;
                    max-width: 200px;
                    font-size: 12px;
                  " class="my-2">
                  {{ i18n.global.locale == "en" ? aa.name_en : aa.name }}
                </div>
                <!-- <div class=" my-4 d-flex align-items-center" v-for="(aaa, kkk) in aa.tableList"
                                    :key="kkk">
                                    <div style="flex:1">
                                        <div class="mx-2"
                                            style="background-color: #9599AD; width:4px; height: 4px; border-radius: 100%; display: inline-block;">
                                        </div>
                                        <span> {{ $t(`${aa.headerList[1]}`) }} : {{ aaa.value1 }}</span>
                                    </div>
                                    <div style="flex:1">
                                        <div class="mx-2"
                                            style="background-color: #9599AD; width:4px; height: 4px; border-radius: 100%; display: inline-block;">
                                        </div>
                                        <span> {{ $t(`${aa.headerList[2]}`) }} : {{ aaa.value2 }}</span>
                                    </div>
                                </div> -->
                <table class="table table-bordered table-nowrap">
                  <thead class="table-light">
                    <tr>
                      <th width="33%">
                        {{ getLangValue(`${aa.headerList[0]}`) }}
                      </th>
                      <th width="33%">
                        {{ getLangValue(`${aa.headerList[1]}`) }}
                      </th>
                      <th width="33%">
                        {{ getLangValue(`${aa.headerList[2]}`) }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style="vertical-align: middle" v-for="(tableData, index_data) in aa.tableList"
                      :key="index_data">
                      <td>{{ index_data + 1 }}</td>
                      <td>{{ tableData.value1 }}</td>
                      <td>{{ tableData.value2 }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </div>
          <Empty v-else></Empty>
        </template>
        <template v-else>
          <template v-if="item.fieldList.length || item.imageList.length">
            <div style="color: #212529" class="row d-flex justify-content-start px-3" v-if="item.fieldList.length">
              <!-- <div class="col-6 my-1 d-flex align-items-center" v-for="(aa, kk) in item.fieldList"
                                :key="kk">
                                <div class="mx-2"
                                    style="background-color: #9599AD; width:4px; height: 4px; border-radius: 100%; display: inline-block;">
                                </div>
                                <span>{{ aa.name }} : {{ aa.value }}{{ aa.unit ? `${aa.unit}` : '' }}</span>
                            </div> -->
              <div v-for="(aa, kk) in item.fieldList" :key="kk" class="d-flex p-2"
                style="border-bottom: 1px solid #e9ebec">
                <div style="
                    font-weight: bold;
                    flex: 2;
                    max-width: 200px;
                    font-size: 12px;
                  ">
                  {{ i18n.global.locale == "en" ? aa.name_en : aa.name }}
                </div>
                <div style="flex: 6">
                  {{ aa.value ? aa.value : "-"
                  }}{{ aa.value && aa.unit ? `${aa.unit}` : "" }}
                </div>
              </div>
            </div>
            <div class="qualityInspectionReport py-4 my-2" v-if="item.imageList.length">
              <div class="d-flex justify-content-start align-items-center">
                <div class="d-flex justify-content-center align-items-center mx-2 file-view"
                  v-for="(image, kk) in item.imageList" :key="kk" style="
                    width: 120px;
                    height: 120px;
                    border-radius: 4px;
                    position: relative;
                  ">
                  <i v-if="image.type == 'file'" class="ri-file-text-line" style="font-size: 110px; color: #0ab39c"></i>
                  <img v-else :src="image.url" alt="" style="object-fit: fill; max-height: 117px"
                    @click="handleImgPreview(image.url)" class="cursor-pointer" />
                  <!-- 文件操作按钮 -->
                  <fileActionCom :image="image" v-if="image.showAction || true" />
                </div>
              </div>
            </div>
          </template>
          <Empty v-else></Empty>
        </template>
      </div>
    </div>
    <!-- </template> -->
    <Empty v-if="
      comfort_info_data[0].data.length == 0 &&
      comfort_info_data[1].data.length == 0 &&
      comfort_info_data[2].data.length == 0 &&
      uploadFileList.length == 0
    ">
    </Empty>
  </div>
</template>
<style scoped></style>
